import React from 'react';
import ReactDOM from 'react-dom';
import App from "App";

import "assets/styles/tailwind.css"

ReactDOM.render(<App/>, document.getElementById('app'));
